import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const BRAND = {
  name: "DES-CARTA LTD",
  tagline: "Recovered Materials Brokerage & Consultancy",
  slogan: "Connecting Waste. Markets. Value.",
  phone: "+44 7359 882396",
  phoneHref: "tel:+447359882396",
  email: "desmondnaseem@des-carta.com",
  location: "London, United Kingdom",
  eaReg: "CBDU654882",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1781243680823-aae6c7f1ff12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwcmVjeWNsaW5nJTIwZmFjaWxpdHl8ZW58MHx8fHwxNzg3NjU3NzE5fDA&ixlib=rb-4.1.0&q=85",
  occ: "https://images.unsplash.com/photo-1719600804011-3bff3909b183?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxjYXJkYm9hcmQlMjBiYWxlc3xlbnwwfHx8fDE3ODc2NTc3MTl8MA&ixlib=rb-4.1.0&q=85",
  logistics: "https://images.pexels.com/photos/11666903/pexels-photo-11666903.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  paperMill: "https://images.unsplash.com/photo-1693031630189-a39e6d70bf22?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxwYXBlciUyMG1pbGwlMjBtYW51ZmFjdHVyaW5nfGVufDB8fHx8MTc4NzY1NzczNHww&ixlib=rb-4.1.0&q=85",
  hauliers: "https://images.unsplash.com/photo-1591419478162-a4dd21b7ec0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxhcnRpY3VsYXRlZCUyMGxvcnJ5JTIwaGlnaHdheXxlbnwwfHx8fDE3ODc2NTc3MzR8MA&ixlib=rb-4.1.0&q=85",
  london: "https://images.unsplash.com/photo-1549483249-f0b359d1e289?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxsb25kb24lMjBza3lsaW5lJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NzY1NzczNHww&ixlib=rb-4.1.0&q=85",
};
